// Which mobility report renderer the app mounts.
//   "v95" (default): the v95 report engine in public/mobility-report/ inside the
//                    sandboxed iframe, plus the static print templates.
//   "v2":            the backend-scored render document (RenderReportDocument).
// Set with REACT_APP_MOBILITY_REPORT_ENGINE at build time.
export const MOBILITY_REPORT_ENGINES = Object.freeze(["v95", "v2"]);

export const resolveMobilityReportEngine = (
  value = process.env.REACT_APP_MOBILITY_REPORT_ENGINE,
) => {
  const engine = String(value || "")
    .trim()
    .toLowerCase();
  return MOBILITY_REPORT_ENGINES.includes(engine) ? engine : "v95";
};

export const MOBILITY_REPORT_ENGINE = resolveMobilityReportEngine();
